import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';

// Lib
import { FACEBOOK, INSTAGRAM } from '@/lib/socialProfile';

import Icon from '@/components/base/Icon';
// Components
import CustomPopover from '@/components/composite/Popover/CustomPopover';

import RandomCommentsPickerForm from './RandomCommentsPickerForm';

const defaultPopperOptions = {
    placement: 'bottom-end',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [52, 12]
            }
        }
    ]
};

const RandomCommentsPicker = ({
    media,
    socialProfile,
    container = document.body,
    popperOptions = defaultPopperOptions,
    children,
    isOpen,
    network,
    toggle,
    onPickCallback,
    results
}) => {
    const [referenceElement, setReferenceElement] = useState();

    const [popperElement, setPopperElement] = useState();
    const { styles, attributes } = usePopper(referenceElement, popperElement, popperOptions);
    const popperStylesWithZIndex = {
        arrow: { ...styles.arrow },
        reference: { ...styles.reference },
        popper: { zIndex: 20, ...styles.popper }
    };

    if (network !== FACEBOOK && network !== INSTAGRAM) {
        return null;
    }

    return (
        <>
            <span className="relative">
                {children({
                    setReferenceElement
                })}
                {(typeof results === 'boolean' && results) || results?.length ? (
                    <div className="absolute -right-1 -top-1.5 z-10 flex h-4 w-4 min-w-min items-center justify-center rounded-full bg-icoBlue">
                        <Icon icon="check" className="text-xxs text-white" />
                    </div>
                ) : null}
            </span>
            {isOpen && container
                ? ReactDOM.createPortal(
                      <CustomPopover
                          open={isOpen}
                          popperElement={popperElement}
                          setPopperElement={setPopperElement}
                          toggle={toggle}
                          styles={popperStylesWithZIndex}
                          attributes={attributes}
                          hasBtnClose={true}
                          closeVariant="lightGray"
                          wrapperClassName="w-full"
                          disableClickOuter={true}
                          customArrowClassName="right-[3.9rem]"
                          customBtnCloseClassName="!top-5 right-7"
                          width="w-full">
                          <RandomCommentsPickerForm
                              media={media}
                              socialProfile={socialProfile}
                              onPickCallback={onPickCallback}
                              closePopover={toggle}
                          />
                      </CustomPopover>,
                      container
                  )
                : null}
        </>
    );
};

export default RandomCommentsPicker;
